<template lang="pug">
  BasePopup(@close="close(false)" v-if="isOpened")
    .b-confirm-popup
      ._text(v-if="text" v-html="preparedText")
      ._text(v-else)
        slot
      ._desc(v-if="desc") {{ desc }}
      ._buttons
        Btn(blue :to="to" @click.native="close(true)") {{ buttonText }}
</template>

<script>
import BasePopup from '@/components/BasePopup.vue';
import colorify from '@/utils/colorify';
import htmlspecialchars from '@/utils/htmlspecialchars';

/**
 * Алерт, у которого вместо кнопки OK — кнопка-ссылка на роут. Открывается
 * через popupModel.addGoto() или this.$goto(). Резолвится true при переходе
 * по ссылке и false при закрытии крестиком/оверлеем.
 */
export default {
  name: 'PopupGoto',
  components: { BasePopup },
  controller: null,
  data() {
    return {
      isOpened: false,
      text: '',
      to: null,
      buttonText: '',
      desc: '',
    };
  },
  computed: {
    preparedText() { return colorify(htmlspecialchars.encode(this.text)); },
  },
  methods: {
    open(text, to, buttonText, desc = '') {
      this.text = text;
      this.to = to;
      this.buttonText = buttonText;
      this.desc = desc;
      this.isOpened = true;

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close(result) {
      this.isOpened = false;
      this.$options.controller.resolve(result);
    },
  },
};
</script>

<style scoped lang="scss">
  .confirm-popup {
    max-width: 536px;

    &__text {
      font-weight: bold;
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 0.02em;
      margin-bottom: 40px;
    }

    &__desc {
      letter-spacing: 0.02em;
      margin-bottom: 40px;
      text-align: center;
    }

    &__buttons {
      display: flex;
      justify-content: center;
      gap: 30px;
    }
  }
</style>
